import { useParams, useNavigate } from "react-router-dom";
import postlist from "../blog/posts/post1.json";
import ReactMarkdown from "react-markdown";
import imageGif from "../componets/assets/images/blogif2.gif";

export default function PostDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const post = postlist.find((post) => post.id === parseInt(id));

  if (!post) return <p>Post not found</p>;

  return (
    <div className="md:w-1/2 py-5 mx-auto pt-16 px-5 md:pt-28 space-y-6">
      <button
        className="text-sm text-zinc-500 hover:text-black"
        onClick={() => navigate(-1)}
      >
        ← Back to posts
      </button>

      <div>
        <h1 className="text-[#5126c7] text-2xl md:text-4xl font-extrabold">
          {post.title.trim()}
        </h1>
        <p className="text-[#000000] text-sm italic">
          {post.title}
        </p>
      </div>
      <div className="border-b pb-2 border-black">
        <img src={post.image} alt="" className="rounded-xl" />
        <div className="pt-4">
          <p className="text-xs text-zinc-500">
            {post.date.trim()} - <span>{post.author.trim()}</span>
          </p>
        </div>
      </div>

      <ReactMarkdown
        components={{
          h2: ({ node, ...props }) => (
            <h2
              className="sm:text-lg text-xs md:text-sm text-[#000000] font-bold  mb-2"
              {...props}
            />
          ),
          p: ({ node, ...props }) => (
            <p className=" text-[#000000] text-xs md:text-sm leading-relaxed" {...props} />
          ),
          em: ({ node, ...props }) => (
            <em className="text-[#069932] text-xs md:text-sm italic" {...props} />
          ),
          strong: ({ node, ...props }) => (
            <strong className="text-[#000000] text-xs md:text-sm font-semibold" {...props} />
          ),
          img: ({ node, src, alt, ...props }) => (
            <img src={src} alt={alt}  className="max-w-full h-auto" {...props} />
          ),
         
          ul: ({ node, ...props }) => (
            <ul className="list-disc text-xs md:text-sm list-inside my-3 space-y-1" {...props} />
          ),
          li: ({ node, ...props }) => (
            <li className="text-[#000000] text-xs md:text-sm leading-relaxed" {...props} />
          ),
           a: ({ node, ...props }) => (
            <a className="text-[#4d09e0] text-xs md:text-sm " {...props} />
          ),
        }}
      >
        {post.content}
      </ReactMarkdown>
    </div>
  );
}
